export default __webpack_public_path__ + "static/media/90bet_login.2cdc6902.svg";